<div *ngIf="showBanner" class="data-privacy-banner">
  <div class="row">
    <div class="columns medium-8 large-9 white-color">
      This website requires cookies, and the limited processing of your personal data in order to function.
      By using the site you are agreeing to this as outlined in our
      <a target="_blank" href="./assets/alphafold-privacy-notice.pdf">Privacy Notice</a> and
      <a target="_blank" href="https://www.ebi.ac.uk/data-protection/privacy-notice/embl-ebi-public-website">Terms of Use</a>.
    </div>
    <div class="columns medium-4 large-3 text-right white-color">
      <a id="data-protection-agree" (click)="closeDataProtectionBanner()">I agree, dismiss this banner</a>
    </div>
  </div>
</div>

 <footer class="vf-footer">
    <div class="vf-footer__inner">
      <p class="vf-footer__notice">
        <a class="vf-footer__link" href="//www.ebi.ac.uk/about/our-impact">
          EMBL-EBI is the home for big data in biology. We help scientists exploit complex information to make discoveries that benefit humankind.
        </a>
      </p>
      <div class="vf-footer__links-group | vf-grid">
        <div class="vf-links">
          <h4 class="vf-links__heading"><a class="vf-heading__link" href="//www.ebi.ac.uk/services">Services</a></h4>
          <ul class="vf-links__list | vf-list">
            <li class="vf-list__item">
              <a href="//www.ebi.ac.uk/services/data-resources-and-tools" class="vf-list__link">Data resources and tools</a>
            </li>
            <li class="vf-list__item">
              <a href="//www.ebi.ac.uk/submission" class="vf-list__link">Data submission</a>
            </li>
            <li class="vf-list__item">
              <a href="//www.ebi.ac.uk/support" class="vf-list__link">Support and feedback</a>
            </li>
            <li class="vf-list__item">
              <a href="//www.ebi.ac.uk/licencing" class="vf-list__link">Licensing</a>
            </li>
          </ul>
        </div>
  
        <div class="vf-links">
          <h4 class="vf-links__heading"><a class="vf-heading__link" href="//www.ebi.ac.uk/research">Research</a></h4>
          <ul class="vf-links__list | vf-list">
            <li class="vf-list__item">
              <a href="//www.ebi.ac.uk/research/publications" class="vf-list__link">Publications</a>
            </li>
            <li class="vf-list__item">
              <a href="//www.ebi.ac.uk/research/groups" class="vf-list__link">Research groups</a>
            </li>
            <li class="vf-list__item vf-footer__notice">
              <a href="//www.ebi.ac.uk/research/postdocs" class="vf-list__link">Postdocs</a>
              and
              <a href="//www.ebi.ac.uk/research/eipp" class="vf-list__link">PhDs</a>
            </li>
          </ul>
        </div>
  
        <div class="vf-links">
          <h4 class="vf-links__heading"><a class="vf-heading__link" href="//www.ebi.ac.uk/training">Training</a></h4>
          <ul class="vf-links__list | vf-list">
            <li class="vf-list__item">
              <a href="//www.ebi.ac.uk/training/live-events" class="vf-list__link">Live training</a>
            </li>
            <li class="vf-list__item">
              <a href="//www.ebi.ac.uk/training/on-demand" class="vf-list__link">On-demand training</a>
            </li>
            <li class="vf-list__item">
              <a href="//www.ebi.ac.uk/training/trainer-support" class="vf-list__link">Support for trainers</a>
            </li>
            <li class="vf-list__item">
              <a href="//www.ebi.ac.uk/training/contact-us" class="vf-list__link">Contact organisers</a>
            </li>
          </ul>
        </div>
  
        <div class="vf-links">
          <h4 class="vf-links__heading"><a class="vf-heading__link" href="//www.ebi.ac.uk/industry">Industry</a></h4>
          <ul class="vf-links__list | vf-list">
            <li class="vf-list__item">
              <a href="//www.ebi.ac.uk/industry/private/members-area/" class="vf-list__link">Members Area</a>
            </li>
            <li class="vf-list__item">
              <a href="//www.ebi.ac.uk/industry/contact-us" class="vf-list__link">Contact Industry team</a>
            </li>
          </ul>
        </div>
  
        <div class="vf-links">
          <h4 class="vf-links__heading"><a class="vf-heading__link" href="//www.ebi.ac.uk/about">About</a></h4>
          <ul class="vf-links__list | vf-list">
            <li class="vf-list__item">
              <a href="//www.ebi.ac.uk/about/contact" class="vf-list__link">Contact us</a>
            </li>
            <li class="vf-list__item">
              <a href="//www.ebi.ac.uk/about/events" class="vf-list__link">Events</a>
            </li>
            <li class="vf-list__item">
              <a href="//www.ebi.ac.uk/about/jobs" class="vf-list__link">Jobs</a>
            </li>
            <li class="vf-list__item">
              <a href="//www.ebi.ac.uk/about/news" class="vf-list__link">News</a>
            </li>
            <li class="vf-list__item">
              <a href="//www.ebi.ac.uk/about/people" class="vf-list__link">People and groups</a>
            </li>
            <li class="vf-list__item">
              <a href="//intranet.ebi.ac.uk" class="vf-list__link">Intranet for staff</a>
            </li>
          </ul>
        </div>
      </div>
  
      <p class="vf-footer__legal">
        <span class="vf-footer__legal-text">
          <a
            class="vf-footer__link"
            href="https://www.google.co.uk/maps/place/Hinxton,+Saffron+Walden+CB10+1SD/@52.0815334,0.1891518,17z/data=!3m1!4b1!4m5!3m4!1s0x47d87ccbfbd2538b:0x7bbdb4cde2779ff3!8m2!3d52.0800838!4d0.186415"
            >EMBL-EBI, Wellcome Genome Campus, Hinxton, Cambridgeshire, CB10 1SD, UK.</a
          >
        </span>
        <span class="vf-footer__legal-text">
          <a class="vf-footer__link" href="tel:00441223494444">Tel: +44 (0)1223 49 44 44</a>
        </span>
        <span class="vf-footer__legal-text">
          <a class="vf-footer__link" href="//www.ebi.ac.uk/about/contact">Full contact details</a>
        </span>
      </p>
      <p class="vf-footer__legal">
        <span class="vf-footer__legal-text"> Copyright © EMBL 2023 </span>
        <span class="vf-footer__legal-text">
          EMBL-EBI is part of the
          <a class="vf-footer__link" href="//www.embl.org">European Molecular Biology Laboratory</a>
        </span>
        <span class="vf-footer__legal-text">
          <a class="vf-footer__link" href="//www.ebi.ac.uk/about/terms-of-use">Terms of use</a>
        </span>
      </p>
    </div>
  </footer>
